import script from "./BlogSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogSection.vue?vue&type=script&setup=true&lang=js"

import "./BlogSection.vue?vue&type=style&index=0&id=1d593993&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d593993"]])

export default __exports__